import { render, staticRenderFns } from "./AlertDialog.component.vue?vue&type=template&id=65b7abe2&scoped=true"
import script from "./AlertDialog.component.vue?vue&type=script&lang=ts"
export * from "./AlertDialog.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7abe2",
  null
  
)

export default component.exports